/* on-fiche.js — fiche produit, refonte DA (05/10/2026, lot L3). Comportement de la fiche du site de référence (app.js:318-739,
   panneau_usages.js, app.js:1535-1557, 1617-1664) porté sur les données ON (window.ON_PRODUIT, window.CATALOGUE, /cart.js via
   window.ON), SANS ses défauts (PORTAGE.md § 4, numéros entre crochets), plus l'alerte « retour en stock » (ex-layout, classes
   .on-alerte* et POST /apps/suivi/alerte gardés). Attend DOMContentLoaded : on-app.js (window.ON) est chargé avant, en defer. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function on() { return window.ON || {}; }
  function prix(n) {
    if (on().prix) return on().prix(n);
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(n) || 0).replace(/ /g, ' ');
  }
  var LARGEURS = [360, 540, 720, 900, 1080];
  function img(url, w) {
    if (on().img) return on().img(url, w);
    try { var u = new URL(url, location.href); u.searchParams.set('width', w); return u.href; } catch (e) { return url; }
  }
  function srcset(url, l) {
    if (on().srcset) return on().srcset(url, l || LARGEURS);
    return (l || LARGEURS).map(function (w) { return img(url, w) + ' ' + w + 'w'; }).join(', ');
  }
  function toast(t) { if (on().toast) on().toast(t); }
  function echapper(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function chemin(u) { try { var x = new URL(u, location.href); return x.pathname; } catch (e) { return u; } }

  function demarrer() {
    var root = $('#pdp'), P = window.ON_PRODUIT;
    if (!root || !P) return;
    var coloris = Array.isArray(P.coloris) && P.coloris.length ? P.coloris : [{ id: P.id, url: P.url, couleur: '', prix: P.prix, promo: P.promo, images: P.images || [], toutes_tailles: [], tailles_dispo: [], var_par_taille: {} }];
    var EU = $('#sizeGrid') && $('#sizeGrid').getAttribute('data-eu') === '1';
    var MOT = root.getAttribute('data-mot') || 'taille';
    var etat = { i: 0, taille: null };
    var ecouteurs = [];          // rappels « coloris changé »
    function courant() { return coloris[etat.i] || coloris[0]; }

    /* ── 1. Galerie : piste défilante, compteur, flèches au bureau, boucle par copie neutre [40] ─────────────────────────── */
    var gal = $('#pdpGal'), compteur = $('.pdp-galbar__n'), galWrap = gal && gal.parentElement;
    function vues() { return gal ? gal.querySelectorAll('figure:not(.pdp-gal__clone)').length : 0; }
    function pas() {
      if (!gal) return 1;
      var f = gal.children[0];
      if (!f) return gal.clientWidth || 1;
      var st = getComputedStyle(gal), g = parseFloat(st.columnGap || st.gap) || 0;
      return f.getBoundingClientRect().width + g || gal.clientWidth || 1;
    }
    function boucler() {
      if (!gal) return;
      var ancien = gal.querySelector('.pdp-gal__clone'); if (ancien) ancien.remove();
      if (vues() < 2) return;
      var copie = gal.children[0].cloneNode(true);
      copie.classList.add('pdp-gal__clone');
      copie.setAttribute('aria-hidden', 'true');
      var im = copie.querySelector('img');
      if (im) { im.removeAttribute('id'); im.removeAttribute('fetchpriority'); im.setAttribute('alt', ''); im.setAttribute('loading', 'lazy'); }
      gal.appendChild(copie);
    }
    function majCompteur() {
      if (!gal) return;
      var total = vues(), brut = gal.__i != null ? gal.__i : Math.round(gal.scrollLeft / pas());
      var i = total ? Math.min(total, (brut % total) + 1) : 1;
      if (compteur) {
        var txt = i + '/' + total;
        if (compteur.textContent !== txt) compteur.textContent = txt;
        var barre = compteur.parentElement; if (barre) barre.style.display = total > 1 ? '' : 'none';
      }
      $$('.pdp-galnav').forEach(function (b) { b.hidden = total < 2; });
    }
    function aller(cible, doux) {
      var total = vues(); if (!gal || total < 2) return;
      if (cible < 0) cible = total - 1;
      if (cible > total) cible = 0;
      gal.scrollTo({ left: cible * pas(), behavior: doux === false ? 'auto' : 'smooth' });
    }
    function peindre(c) {
      if (!gal || !c || !c.images || !c.images.length) return;
      var nom = P.nom || '';
      gal.innerHTML = c.images.map(function (src, k) {
        return '<figure><img' + (k === 0 ? ' id="pdpMain"' : '') + ' src="' + echapper(img(src, 900)) + '" srcset="' + echapper(srcset(src)) +
          '" sizes="(min-width: 1000px) 56vw, 100vw" alt="' + echapper(nom + ' coloris ' + (c.couleur || '') + ' — vue ' + (k + 1)) +
          '" width="1000" height="1000"' + (k === 0 ? '' : ' loading="lazy"') + ' decoding="async"></figure>';
      }).join('');
      gal.classList.toggle('pdp-gal--solo', c.images.length === 1);
      gal.style.scrollBehavior = 'auto'; gal.scrollLeft = 0; gal.style.scrollBehavior = '';
      gal.__i = 0;
      boucler(); majCompteur();
    }
    if (gal) {
      gal.__i = 0;
      boucler(); majCompteur();
      gal.addEventListener('scroll', function () {
        if (gal.__t) return;
        gal.__t = requestAnimationFrame(function () {
          gal.__t = null;
          gal.__i = Math.round(gal.scrollLeft / pas());
          majCompteur();
          clearTimeout(gal.__fin);
          gal.__fin = setTimeout(function () {
            var total = vues();
            if (total < 2 || gal.__i < total) return;
            gal.style.scrollBehavior = 'auto'; gal.scrollLeft = 0; gal.style.scrollBehavior = '';
            gal.__i = 0; majCompteur();
          }, 150);
        });
      }, { passive: true });
      gal.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        aller(Math.round(gal.scrollLeft / pas()) + (e.key === 'ArrowRight' ? 1 : -1));
      });
      $$('.pdp-galnav').forEach(function (b) {
        b.addEventListener('click', function () {
          var i = Math.round(gal.scrollLeft / pas());
          aller(b.classList.contains('pdp-galnav--next') ? i + 1 : i - 1);
        });
      });
      window.addEventListener('resize', function () { clearTimeout(gal.__r); gal.__r = setTimeout(function () { aller(gal.__i || 0, false); }, 150); });
    }

    /* ── 2. Prix, rareté, tailles : repeints pour le coloris courant ──────────────────────────────────────────────────────── */
    function htmlPrix(c, espace) {
      var paye = c.promo > 0 ? c.promo : c.prix, barre = c.promo > 0 ? c.prix : 0;
      return '<b>' + prix(paye) + '</b>' + (barre > paye ? (espace ? ' ' : '') + '<s>' + prix(barre) + '</s>' : '');
    }
    function libelle(t) { return String(t).replace('.', ','); }
    // Grille de pointures : toutes les tailles, épuisées barrées et désactivées.
    function majOptions(c) {
      var grille = $('#sizeGrid');
      var toutes = (c.toutes_tailles && c.toutes_tailles.length) ? c.toutes_tailles : null;
      if (!toutes || !grille) return;
      var dispo = {}; (c.tailles_dispo || []).forEach(function (t) { dispo[t] = 1; });
      var garde = etat.taille && dispo[etat.taille] ? etat.taille : '';
      grille.innerHTML = toutes.map(function (t) {
        var v = c.var_par_taille && c.var_par_taille[t];
        return '<button type="button" role="radio" aria-checked="false" class="size-btn' + (dispo[t] ? '' : ' is-rupture') + '" data-taille="' + echapper(t) + '"'
          + (v ? ' data-variante="' + v.id + '"' : '') + (dispo[t] ? '' : ' disabled aria-disabled="true"') + '>' + echapper(libelle(t)) + '</button>';
      }).join('');
      var acces = $('.on-alerte-acces'), nRup = toutes.filter(function (t) { return !dispo[t]; }).length;
      if (acces) acces.hidden = !nRup;   // fiche entièrement épuisée comprise : c'est là que l'alerte sert le plus (PORTAGE § 2.4)
      definirTaille(garde || seule());
    }
    // Une seule taille, disponible (« Taille unique ») : elle est choisie d'office, comme le ferait le client.
    function seule() {
      var b = $$('#sizeGrid .size-btn');
      return b.length === 1 && !b[0].disabled ? b[0].getAttribute('data-taille') : '';
    }
    function majEtatAchat(c) {
      var nDispo = (c.tailles_dispo || []).length, nt = (c.toutes_tailles || []).length;
      var epuise = nt > 0 && nDispo === 0;
      var rar = $('#pdpRupture'); if (rar) rar.hidden = !(nDispo > 0 && nDispo <= 2 && nt >= 4);
      ['addBtn', 'buybarBtn'].forEach(function (id) {
        var b = document.getElementById(id); if (!b) return;
        b.disabled = epuise; b.textContent = epuise ? 'Épuisé' : 'Ajouter au panier';
      });
      $$('.size-hint-auto, .size-reassure-auto, .pdp-reassure-auto').forEach(function (p) { p.hidden = epuise; });
    }
    function majPrix(c) {
      var p = $('#pdpPrix'); if (p && c.prix) p.innerHTML = htmlPrix(c, false);
      var b = $('#buybarPrix'); if (b && c.prix) b.innerHTML = htmlPrix(c, true);
    }

    /* ── 3. Coloris : changés SUR PLACE quand ON_PRODUIT porte le coloris, sinon lien vers sa fiche [41] ─────────────────── */
    var sw = $('#pdpSw'), swBtns = sw ? $$('.pdp-sw__i', sw) : [];
    function complet(c) { return c && c.images && c.images.length && c.toutes_tailles && c.toutes_tailles.length && c.var_par_taille; }
    function choisirColoris(i) {
      var c = coloris[i]; if (!complet(c)) return false;
      etat.i = i;
      var nom = $('#colorName'); if (nom) nom.textContent = c.couleur || '';
      swBtns.forEach(function (b, k) {
        var actif = k === i; b.classList.toggle('is-active', actif);
        if (actif) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      peindre(c); majPrix(c); majOptions(c); majEtatAchat(c);
      if (c.url && history.replaceState) { try { history.replaceState(history.state, '', chemin(c.url) + location.search.replace(/([?&])variant=\d+&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {} }
      ecouteurs.forEach(function (f) { f(c); });
      return true;
    }
    swBtns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;   // ouverture dans un onglet : le lien sert
        var i = Number(b.getAttribute('data-i')) || 0;
        if (i === etat.i) { e.preventDefault(); return; }
        if (choisirColoris(i)) e.preventDefault();
      });
    });
    // Une seule rangée sous 1000 px, « Voir les N coloris » qui déplie ET replie [41] ; la pastille active reste visible.
    (function plier() {
      var lab = $('.pdp-opt--coloris button.pdp-opt__n');
      if (!sw || !lab || swBtns.length < 2) return;
      var total = swBtns.length, deplie = false;
      function appliquer() {
        swBtns.forEach(function (b) { b.hidden = false; });
        if (window.innerWidth >= 1000) { lab.textContent = total + ' coloris'; lab.classList.remove('pdp-opt__n--plus'); lab.setAttribute('aria-expanded', 'true'); return; }
        var premiere = swBtns[0].offsetTop, tiennent = swBtns.filter(function (b) { return b.offsetTop === premiere; }).length;
        if (tiennent >= total) { lab.textContent = total + ' coloris'; lab.classList.remove('pdp-opt__n--plus'); lab.setAttribute('aria-expanded', 'true'); return; }
        var actif = -1; swBtns.forEach(function (b, k) { if (b.classList.contains('is-active')) actif = k; });
        if (actif >= tiennent && !deplie) deplie = true;
        lab.classList.add('pdp-opt__n--plus');
        lab.setAttribute('aria-expanded', String(deplie));
        if (deplie) { lab.textContent = 'Masquer les coloris'; return; }
        swBtns.forEach(function (b, k) { b.hidden = k >= tiennent; });
        lab.textContent = 'Voir les ' + total + ' coloris';
      }
      lab.addEventListener('click', function () { if (window.innerWidth >= 1000) return; deplie = !deplie; appliquer(); });
      var m; window.addEventListener('resize', function () { clearTimeout(m); m = setTimeout(appliquer, 150); });
      appliquer();
    })();

    /* ── 4. Taille : grille de boutons ; une taille épuisée est barrée, l'alerte passe par son lien ─── */
    var grille = $('#sizeGrid'), erreur = $('#sizeErreur'), buybar = $('#buybar'), addBtn = $('#addBtn'), bbBtn = $('#buybarBtn');
    function definirTaille(t) {
      etat.taille = t || null;
      $$('#sizeGrid .size-btn').forEach(function (b) {
        var oui = !!t && b.getAttribute('data-taille') === t;
        b.classList.toggle('is-selected', oui); b.setAttribute('aria-checked', String(oui));
      });
      if (t && erreur) erreur.hidden = true;
      if (t && buybar) buybar.classList.remove('need-size');            // [8]
    }
    if (grille) {
      grille.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.size-btn');
        if (!b || b.disabled) return;
        alerte.fermer();
        definirTaille(b.getAttribute('data-taille'));
      });
      // Flèches du clavier dans le groupe de boutons radio (comme un groupe natif).
      grille.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) < 0) return;
        var l = $$('#sizeGrid .size-btn:not([disabled])'), k = l.indexOf(document.activeElement); if (k < 0) return;
        e.preventDefault(); var n = l[(k + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : l.length - 1)) % l.length];
        n.focus(); definirTaille(n.getAttribute('data-taille'));
      });
    }
    if (seule()) definirTaille(seule());

    /* ── 5. Ajout au panier : sans taille, toast ; avec taille, ON.panier.ajouter puis ON.panier.ouvrir ─────────────────── */
    function demanderTaille() {
      if (erreur) erreur.hidden = false;
      var wrap = $('.sizes', root);
      if (wrap) {
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        wrap.classList.add('sizes--ask');
        setTimeout(function () { wrap.classList.remove('sizes--ask'); }, 1600);
      }
      var premier = $('#sizeGrid .size-btn:not([disabled])');
      if (premier) setTimeout(function () { try { premier.focus({ preventScroll: true }); } catch (e) { premier.focus(); } }, 450);
    }
    var envoi = false;
    function ajouter(e) {
      var declencheur = (e && e.currentTarget) || document.activeElement;
      if (!etat.taille) { demanderTaille(); return; }
      var c = courant(), v = c.var_par_taille && c.var_par_taille[etat.taille];
      if (!v || envoi) return;
      envoi = true;
      [addBtn, bbBtn].forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
      var fin = function () { envoi = false; [addBtn, bbBtn].forEach(function (b) { if (b) b.removeAttribute('aria-busy'); }); };
      var p;
      // ON.panier.ajouter signale lui-même l'échec (toast) ; repli sans on-app.js : /cart/add.js puis la page panier.
      if (on().panier && on().panier.ajouter) p = Promise.resolve(on().panier.ajouter(v.id, 1, { ouvrir: false })).then(function (r) { on().panier.ouvrir(declencheur); return r; });
      else p = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); location.href = '/cart'; });
      p.then(fin, fin);
    }
    if (addBtn) addBtn.addEventListener('click', ajouter);

    /* ── 6. Barre d'achat collante, synchronisée ; réserve basse = sa hauteur réelle [5][6][7][8] ────────────────────────── */
    if (buybar && addBtn) {
      var attente = false;
      // la barre d'achat est là PARTOUT tant que le vrai bouton n'est pas ENTIÈREMENT visible — au-dessus
      // comme en dessous de l'écran — et s'efface quand on le voit. « Visible » = entre le haut de l'écran et le haut de la barre
      // d'onglets (relevé en direct : elle peut être remontée, par ex. au-dessus de la barre d'aperçu de Shopify).
      var majBarre = function () {
        attente = false;
        var r = addBtn.getBoundingClientRect(), act = document.querySelector('.hdr-act');
        var bas = act && getComputedStyle(act).position === 'fixed' ? act.getBoundingClientRect().top : window.innerHeight;
        var visible = r.height > 0 && r.top >= 0 && r.bottom <= bas;
        // … sauf là où elle RECOUVRIRAIT la grille des tailles ou le panneau d'alerte (mesuré à 390 : 10 tailles sur 14 sous la barre
        // quand la grille arrive en bas d'écran ; le toucher partait alors sur la barre, sans taille). Elle revient dès que la grille
        // n'est plus dans sa bande.
        var haut = bas - (buybar.offsetHeight || 76) - 8;
        var couvre = ['#sizeGrid', '.on-alerte:not([hidden])'].some(function (s) {
          var e = $(s); if (!e) return false; var g = e.getBoundingClientRect(); return g.height > 0 && g.bottom > haut && g.top < bas;
        });
        buybar.classList.toggle('show', !visible && !couvre && !addBtn.disabled);
      };
      var demander = function () { if (attente) return; attente = true; requestAnimationFrame(majBarre); };
      window.addEventListener('scroll', demander, { passive: true });
      window.addEventListener('resize', demander);
      document.addEventListener('on:panier', demander);
      ecouteurs.push(demander);   // coloris changé sur place (épuisé → barre retirée, sans attendre un défilement)
      majBarre();
      var poser = function () { var h = buybar.offsetHeight; if (h) document.documentElement.style.setProperty('--achat-h', h + 'px'); };
      if ('ResizeObserver' in window) new ResizeObserver(poser).observe(buybar);
      poser(); window.addEventListener('resize', poser);
      if (bbBtn) bbBtn.addEventListener('click', function () {
        if (!etat.taille) { buybar.classList.add('need-size'); demanderTaille(); return; }
        buybar.classList.remove('need-size');
        ajouter({ currentTarget: bbBtn });
      });
      var bc = $('.buybar__cart', buybar);
      if (bc) bc.addEventListener('click', function (e) {
        e.preventDefault();
        if (on().panier && on().panier.ouvrir) on().panier.ouvrir(bc); else location.href = '/cart';
      });
      var compte = bc && $('.cart-count', bc);
      var majCompte = function (n) { if (!compte) return; n = Number(n) || 0; compte.textContent = n; compte.hidden = n < 1; };
      document.addEventListener('on:panier', function (e) {
        var d = e && e.detail, n = d && (d.item_count != null ? d.item_count : (d.cart && d.cart.item_count));
        if (n != null) majCompte(n);
      });
      var hc = $('#cartBtn .cart-count'); if (hc && !hc.hidden && hc.style.display !== 'none') majCompte(hc.textContent);
    }

    /* ── 7. Alerte « retour en stock » : lien « Votre … est indisponible ? Être prévenu(e) » → choix de la
          taille épuisée + e-mail. Classes .on-alerte* et POST /apps/suivi/alerte inchangés (Worker, étape 16). ──────────────── */
    var alerte = (function () {
      var acces = $('.on-alerte-acces'), lien = acces && $('.on-alerte__ouvrir', acces), panneau = null, taille = '';
      function ruptures() {
        var c = courant(), dispo = {}; (c.tailles_dispo || []).forEach(function (t) { dispo[t] = 1; });
        return (c.toutes_tailles || []).filter(function (t) { return !dispo[t]; });
      }
      function choisir(t) {
        taille = t || '';
        $$('.on-alerte__taille', panneau).forEach(function (b) { var oui = b.getAttribute('data-taille') === taille; b.classList.toggle('is-selected', oui); b.setAttribute('aria-checked', String(oui)); });
      }
      function construire() {
        panneau = document.createElement('div'); panneau.className = 'on-alerte'; panneau.id = 'onAlerte'; panneau.hidden = true;
        panneau.innerHTML = '<form class="on-alerte__form" novalidate><p class="on-alerte__titre">Quelle ' + MOT + ' vous faut-il&nbsp;?</p>'
          + '<div class="on-alerte__tailles" role="radiogroup" aria-label="' + MOT.charAt(0).toUpperCase() + MOT.slice(1) + ' souhaitée"></div>'
          + '<input type="text" name="site_web" class="on-alerte__piege" tabindex="-1" autocomplete="off" aria-hidden="true">'
          + '<div class="on-alerte__ligne"><input type="email" class="on-alerte__mail" placeholder="Votre adresse e-mail" aria-label="Votre adresse e-mail" autocomplete="email" required>'
          + '<button type="submit" class="btn on-alerte__envoyer">Me prévenir</button></div>'
          + '<p class="on-alerte__note">Un seul e-mail, le jour où votre ' + MOT + ' revient. Rien d’autre.</p></form>'
          + '<p class="on-alerte__retour" role="status" aria-live="polite" hidden></p>';
        acces.parentNode.insertBefore(panneau, acces.nextSibling);
        panneau.querySelector('.on-alerte__form').addEventListener('submit', envoyer);
        panneau.querySelector('.on-alerte__tailles').addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.on-alerte__taille'); if (b) choisir(b.getAttribute('data-taille')); });
        if (lien) lien.setAttribute('aria-controls', 'onAlerte');
      }
      function remplir() {
        var l = ruptures();
        panneau.querySelector('.on-alerte__tailles').innerHTML = l.map(function (t) {
          return '<button type="button" role="radio" aria-checked="false" class="on-alerte__taille" data-taille="' + echapper(t) + '">' + echapper(libelle(t)) + '</button>';
        }).join('');
        if (l.length === 1) choisir(l[0]); else choisir(l.indexOf(taille) >= 0 ? taille : '');
      }
      function fermer() { if (panneau) panneau.hidden = true; if (lien) lien.setAttribute('aria-expanded', 'false'); }
      function ouvrir(t) {
        if (!acces) return;
        if (!panneau) construire();
        remplir(); if (t) choisir(t);
        panneau.querySelector('.on-alerte__form').hidden = false; panneau.querySelector('.on-alerte__retour').hidden = true;
        panneau.hidden = false; if (lien) lien.setAttribute('aria-expanded', 'true');
        var r = panneau.getBoundingClientRect();
        if (r.bottom > window.innerHeight - 80 || r.top < 0) panneau.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      if (lien) lien.addEventListener('click', function () { if (panneau && !panneau.hidden) fermer(); else ouvrir(''); });
      function envoyer(e) {
        e.preventDefault();
        var f = e.target, mail = f.querySelector('.on-alerte__mail'), bouton = f.querySelector('.on-alerte__envoyer'), retour = panneau.querySelector('.on-alerte__retour');
        var dire = function (m, ok) { retour.hidden = false; retour.textContent = m; retour.className = 'on-alerte__retour' + (ok ? ' is-ok' : ' is-erreur'); };
        var c = courant(), v = c && c.var_par_taille && c.var_par_taille[taille];
        if (!v) { dire('Choisissez la ' + MOT + ' souhaitée.', false); return; }
        if (!mail.value || !mail.checkValidity()) { dire('Indiquez une adresse e-mail valide.', false); mail.focus(); return; }
        bouton.disabled = true;
        fetch(new URL(c.url, location.href).pathname.replace(/\/?$/, '.js'), { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (p) { return fetch('/apps/suivi/alerte', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ produit: p.id, variation: v.id, taille: taille, email: mail.value, site_web: f.querySelector('.on-alerte__piege').value }) }); })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (x) { dire(x.j.message || (x.ok ? 'C’est noté.' : 'Une erreur est survenue.'), x.ok); if (x.ok) f.hidden = true; })
          .catch(function () { dire('Connexion interrompue : réessayez dans un instant.', false); })
          .then(function () { bouton.disabled = false; });
      }
      return { ouvrir: ouvrir, fermer: fermer };
    })();
    ecouteurs.push(function () { alerte.fermer(); });

    /* ── 8. Puces d'usage : panneau noir (dialogue NON modal, sans aria-modal [13]) ; bureau : dans la colonne [48] ──────── */
    (function usages() {
      var TEXTES = {
        'running': 'Pour courir avant tout : footing, sorties régulières, séances et courses. La chaussure est pensée autour de la foulée, de l’amorti et du déroulé du pied.',
        'running-sur-route': 'Pour le bitume et les surfaces dures et régulières : trottoirs, routes, pistes, tapis de course. La semelle privilégie l’amorti et un déroulé fluide, kilomètre après kilomètre.',
        'running-de-trail': 'Pour courir hors du bitume : chemins, racines, cailloux, boue et dénivelé. L’accroche de la semelle et la protection du pied passent avant la vitesse.',
        'randonnee': 'Pour marcher longtemps sur des sentiers qui changent : maintien, accroche en descente et, selon les modèles, protection contre l’humidité.',
        'lifestyle': 'Pour la ville et le quotidien, en dehors du sport. Le confort vient du running, la silhouette est faite pour être portée toute la journée.',
        'training-et-fitness': 'Pour la salle : renforcement, circuits, cardio, cours collectifs. Une base stable qui encaisse les appuis latéraux et les changements de direction.',
        'tennis': 'Pour le court ou dans son style : appuis latéraux, freinages et glissades pour les modèles de jeu, allure tennis pour les modèles de ville.',
        'athletisme': 'Pour la piste et le cross : séances spécifiques et compétitions. Ces modèles, souvent à pointes, ne sont faits ni pour la route ni pour le quotidien.',
        'marathon': 'Pour les longues distances sur route, de la préparation au jour de course : un amorti qui tient jusqu’au bout et une foulée économique.',
        'competition': 'Pour le jour de course et les séances les plus rapides : légèreté et propulsion avant tout, au détriment de la polyvalence.',
        'voyage': 'Pour les journées de déplacement : facile à enfiler, légère à transporter et confortable pendant de longues heures.'
      };
      var puces = $$('.pdp-tags [data-usage]').filter(function (c) { return TEXTES[c.getAttribute('data-usage')]; });
      if (!puces.length) return;
      var dlg = null, txt = null, croix = null, active = null, minuteur = null, branche = false;
      var bureau = function () { return window.matchMedia('(min-width: 1024px)').matches; };
      function construire() {
        dlg = document.createElement('dialog');
        dlg.className = 'pdp-usage';
        dlg.innerHTML = '<div class="pdp-usage__hd"><button type="button" class="pdp-usage__x" aria-label="Fermer"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg></button></div><div class="pdp-usage__bd"><p class="pdp-usage__txt" tabindex="0"></p></div>';
        txt = dlg.querySelector('.pdp-usage__txt'); croix = dlg.querySelector('.pdp-usage__x');
        croix.addEventListener('click', function () { fermer(true); });
        dlg.addEventListener('cancel', function (e) { e.preventDefault(); fermer(true); });
      }
      function placer() {
        if (!dlg) return;
        var liste = $('.pdp-tags');
        if (bureau()) { if (liste && dlg.previousElementSibling !== liste) liste.parentNode.insertBefore(dlg, liste.nextSibling); }
        else if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      }
      function marquer(c) { puces.forEach(function (p) { p.setAttribute('aria-pressed', String(p === c)); }); }
      function ouvrir(c) {
        if (!dlg) construire();
        if (minuteur) { clearTimeout(minuteur); minuteur = null; }
        dlg.classList.remove('is-ferme');
        txt.textContent = TEXTES[c.getAttribute('data-usage')]; txt.scrollTop = 0;
        dlg.setAttribute('aria-label', (c.textContent || '').trim());
        active = c; marquer(c); placer();
        if (!dlg.open) dlg.show();
        void dlg.offsetWidth;
        dlg.classList.add('is-ouvert');
        croix.focus({ preventScroll: true });
        brancher();
      }
      function fermer(rendre) {
        if (!dlg || !dlg.open) return;
        var c = active; active = null; marquer(null); debrancher();
        dlg.classList.remove('is-ouvert'); dlg.classList.add('is-ferme');
        if (minuteur) clearTimeout(minuteur);
        minuteur = setTimeout(function () { minuteur = null; dlg.classList.remove('is-ferme'); if (dlg.open) dlg.close(); }, 160);
        if (rendre && c) c.focus({ preventScroll: true });
      }
      function echap(e) { if (e.key === 'Escape') { e.preventDefault(); fermer(true); } }
      function dehors(e) { if (dlg.contains(e.target) || (e.target.closest && e.target.closest('.pdp-tags [data-usage]'))) return; fermer(false); }
      function brancher() { if (branche) return; branche = true; document.addEventListener('keydown', echap); document.addEventListener('pointerdown', dehors, true); }
      function debrancher() { if (!branche) return; branche = false; document.removeEventListener('keydown', echap); document.removeEventListener('pointerdown', dehors, true); }
      puces.forEach(function (c) {
        c.addEventListener('click', function () { if (active === c) fermer(true); else ouvrir(c); });
        c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); } });
      });
      window.addEventListener('resize', function () { if (dlg && dlg.open) placer(); });
    })();

    /* ── 9. Bouton « i » des caractéristiques : explication au clic, Échap, aria-expanded dès le départ [44] ─────────────── */
    var AIDES = {
      'Style de running sur route': 'Le ressenti dominant de la chaussure sur route. Stable : maintien et guidage du pied. Fluide : déroulé doux et régulier. Réactif : amorti dynamique qui relance la foulée. Rapide : légèreté et propulsion pour les allures élevées.',
      'Laçage': 'Le système de fermeture. Standard : lacets classiques à nouer. Vitesse : lacets élastiques à serrage rapide, sans nœud. Fermeture à scratch : brides auto-agrippantes. Sans lacets : chaussure à enfiler.',
      'Inclinaison talon-orteils': 'La différence de hauteur entre le talon et l’avant-pied, en millimètres (le « drop »). Plus elle est faible, plus la foulée sollicite l’avant du pied et les mollets.',
      'Poids': 'Le poids d’une seule chaussure ou d’un seul article.',
      'Amorti': 'Le niveau d’amorti de la semelle intermédiaire : plus il est élevé, plus l’impact est absorbé à chaque foulée.',
      'Terrain': 'Le type de terrain pour lequel la semelle est conçue, du chemin roulant au sentier technique (rochers, racines, fortes pentes).',
      'Stabilité': 'Le niveau de maintien apporté pour limiter le roulement du pied vers l’intérieur à l’appui.',
      'Surface': 'La surface de jeu pour laquelle la semelle est conçue : surface dure, terre battue ou toutes surfaces (multi-court).',
      'Coupe': 'La façon dont le vêtement tombe : ajustée près du corps, normale, ou ample pour plus de liberté de mouvement.',
      'Temps': 'Les conditions pour lesquelles l’article est pensé : chaud, froid, ou tout climat.',
      'Imperméabilité': 'Le niveau de protection contre la pluie et le vent : déperlant (l’eau perle en surface), imperméable, ou coupe-vent.',
      'Maintien': 'Le niveau de soutien apporté pendant l’effort : faible, moyen ou fort.'
    };
    $$('.pdp-on-i').forEach(function (b) { if (!AIDES[b.getAttribute('data-aide')]) b.remove(); });
    function fermerAides(sauf) {
      $$('.pdp-on-i-pop').forEach(function (p) { if (p !== sauf) p.remove(); });
      $$('.pdp-on-i[aria-expanded="true"]').forEach(function (b) { if (!sauf || b !== sauf.__bouton) b.setAttribute('aria-expanded', 'false'); });
    }
    document.addEventListener('click', function (e) {
      var bt = e.target.closest ? e.target.closest('.pdp-on-i') : null;
      if (!bt) { if (!(e.target.closest && e.target.closest('.pdp-on-i-pop'))) fermerAides(null); return; }
      e.preventDefault();
      var lab = bt.closest('.pdp-on-spec__lab'), suiv = lab.parentNode.querySelector('.pdp-on-i-pop');
      if (suiv) { fermerAides(null); return; }
      fermerAides(null);
      var pop = document.createElement('p');
      pop.className = 'pdp-on-i-pop'; pop.setAttribute('role', 'note'); pop.__bouton = bt;
      pop.textContent = AIDES[bt.getAttribute('data-aide')] || '';
      lab.parentNode.appendChild(pop);
      bt.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !$('.pdp-on-i-pop')) return;
      var b = $('.pdp-on-i[aria-expanded="true"]'); fermerAides(null); if (b) b.focus();
    });

    /* ── 10. Matières : traduites, ou masquées si un mot reste en anglais (défaut ON : 1 542 fiches en anglais) ───────────── */
    (function matieres() {
      var tr = $('tr[data-matieres]'); if (!tr) return;
      var td = tr.querySelector('td'), s = td.textContent.trim();
      var DICO = [
        [/\bmain fabric\b/gi, 'Tissu principal'], [/\bsecondary fabric\b/gi, 'Tissu secondaire'], [/\bmesh\b/gi, 'Maille'], [/\blining\b/gi, 'Doublure'],
        [/\bupper\b/gi, 'Tige'], [/\boutsole\b/gi, 'Semelle extérieure'], [/\bmidsole\b/gi, 'Semelle intermédiaire'], [/\binsole\b/gi, 'Semelle intérieure'],
        [/\bfilling\b/gi, 'Garnissage'], [/\binsert\b/gi, 'Empiècement'], [/\bpanel\b/gi, 'Empiècement'], [/\btrim\b/gi, 'Finitions'],
        [/\bmerino wool\b/gi, 'laine mérinos'], [/\bwool\b/gi, 'laine'], [/\borganic cotton\b/gi, 'coton biologique'], [/\bcotton\b/gi, 'coton'],
        [/\belastane\b/gi, 'élasthanne'], [/\bspandex\b/gi, 'élasthanne'], [/\brecycled\b/gi, 'recyclé'], [/\bpolyester\b/gi, 'polyester'],
        [/\bpolyamide\b/gi, 'polyamide'], [/\bnylon\b/gi, 'nylon'], [/\brubber\b/gi, 'caoutchouc'], [/\bleather\b/gi, 'cuir'], [/\bsuede\b/gi, 'daim'],
        [/\bpolyurethane\b/gi, 'polyuréthane'], [/\bacrylic\b/gi, 'acrylique'], [/\bviscose\b/gi, 'viscose'], [/\blyocell\b/gi, 'lyocell'],
        [/\bpolypropylene\b/gi, 'polypropylène'], [/\bsilk\b/gi, 'soie'], [/\bdown\b/gi, 'duvet'], [/\bfeathers?\b/gi, 'plumes'], [/\bmodal\b/gi, 'modal']
      ];
      var FR = /^(tissu|principal|secondaire|maille|doublure|tige|semelle|extérieure|intermédiaire|intérieure|garnissage|empiècement|finitions|laine|mérinos|coton|biologique|élasthanne|recyclé|recyclée|polyester|polyamide|nylon|caoutchouc|cuir|daim|polyuréthane|acrylique|viscose|lyocell|polypropylène|soie|duvet|plumes|modal|eva|tpu|rws|gots|grs|rds|bluesign|et|de|du|la|le|les)$/i;
      var t = s;
      DICO.forEach(function (d) { t = t.replace(d[0], d[1]); });
      var mots = t.match(/[A-Za-zÀ-ÿ]+/g) || [];
      if (!mots.length || !mots.every(function (m) { return FR.test(m); })) return;   // reste de l'anglais : la ligne reste masquée
      t = t.replace(/\s*:\s*/g, ' : ').replace(/\s+%/g, ' %').replace(/(\d)%/g, '$1 %').replace(/\s+\./g, '.').replace(/\.$/, '');
      td.textContent = t.charAt(0).toUpperCase() + t.slice(1);
      tr.hidden = false;
    })();

    /* ── 11. Technologies : noms relevés dans les caractéristiques (® ™), puces non cliquables ───────────────────────────── */
    (function technos() {
      var bloc = $('.pdp-on-techno'); if (!bloc) return;
      var vus = {}, noms = [];
      (P.points_forts || []).forEach(function (p) {
        // Un nom = le mot collé à ® ou ™ ; on y joint le mot d'avant s'il est lui-même un nom de marque (majuscule interne :
        // « CloudTec Phase® »). « mousse Helion™ » donne « Helion™ », « Tissu On DryTec™ » donne « DryTec™ ».
        var mots = p.split(/\s+/);
        mots.forEach(function (w, k) {
          var x = w.match(/^[«“"(]?([^\s®™]+?)([®™])/); if (!x) return;
          var nom = x[1], avant = mots[k - 1] || '';
          if (!/^[A-Z]/.test(nom)) return;
          if (!/[a-z][A-Z]/.test(nom) && /^[A-Z][a-z]+[A-Z][a-z]/.test(avant)) nom = avant + ' ' + nom;
          var cle = nom.toLowerCase();
          if (vus[cle]) return; vus[cle] = 1; noms.push(nom + x[2]);
        });
      });
      if (!noms.length) return;
      $('.pdp-on-techno__l', bloc).innerHTML = noms.slice(0, 8).map(function (n) { return '<li class="pdp-on-techno__c"><span class="pdp-on-techno__n">' + echapper(n) + '</span></li>'; }).join('');
      bloc.hidden = false;
    })();

    /* ── 12. Rail « Dans le même esprit » : onrunning.recos, complété par le même rayon et la même sous-catégorie ────────── */
    (function rail() {
      var sec = $('.pdp-reco'), piste = sec && $('.rail', sec), C = window.CATALOGUE;
      if (!sec || !piste || !Array.isArray(C) || !on().carte) return;
      var ids = []; try { ids = JSON.parse(sec.getAttribute('data-recos') || '[]'); } catch (e) {}
      var moi = {}; coloris.forEach(function (c) { moi[c.id] = 1; }); moi[P.id] = 1;
      var parColoris = {}; C.forEach(function (g) { (g.coloris || []).forEach(function (c) { parColoris[c.id] = g; }); });
      var pris = {}, cartes = [];
      var prendre = function (g, idc) {
        if (!g || pris[g.id] || cartes.length >= 8) return;
        if ((g.coloris || []).some(function (c) { return moi[c.id]; })) return;
        pris[g.id] = 1; cartes.push({ g: g, c: idc });
      };
      ids.forEach(function (id) { prendre(parColoris[id], id); });
      C.forEach(function (g) { if (g.rayon === P.rayon && g.sous_cat === P.sous_cat) prendre(g, null); });
      if (!cartes.length) return;
      var html = '', SIZES = '(min-width: 1200px) 23.5vw, (min-width: 900px) 36vw, (min-width: 600px) 47vw, 74vw';
      cartes.forEach(function (x, k) {
        var o = { sizes: SIZES, eager: false }; if (x.c != null) o.coloris = x.c;
        var r = on().carte(x.g, o);
        if (typeof r === 'string') html += r; else if (r && r.nodeType) { piste.appendChild(r); }
        void k;
      });
      if (html) piste.insertAdjacentHTML('beforeend', html);
      if (!piste.children.length) return;
      sec.hidden = false;
      if (on().rails) on().rails(sec);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
